import { getExtendedProperty } from 'owa-folders-common';
import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';

const REMOTE_FOLDER_DISPLAY_NAME_EXTENDED_PROPERTY_TAG = '0x7018';

const getRemoteFolderDisplayNameProperty = (folderItem: BaseFolderType): string =>
    getExtendedProperty(folderItem, REMOTE_FOLDER_DISPLAY_NAME_EXTENDED_PROPERTY_TAG);

export default getRemoteFolderDisplayNameProperty;
